import * as types from './actionTypes';  
import offeringIndustriesApi from '../api/offeringIndustriesApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2'

export function offeringIndustriesList() {
  return {
    type: types.OFFERING_INDUSTRIES_LIST, 
  };
}

export function offeringIndustriesListRes(data) {  
  return {
    type: types.OFFERING_INDUSTRIES_LIST_RES, 
    data
  };
}

export function getOfferingIndustries() {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      offeringIndustriesApi.offeringIndustriesList().then(data => {
        dispatch(offeringIndustriesListRes(data));
        dispatch(offeringIndustriesListRes(null));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          })
        }
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
}
